import { render } from "./PageButton.vue?vue&type=template&id=d83b43da&scoped=true"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"

import "./PageButton.vue?vue&type=style&index=0&id=d83b43da&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83b43da"]])

export default __exports__